module.exports = __webpack_public_path__ + "static/media/coffee-break.de76fcb4.svg";